import { Link, useLocation } from 'react-router-dom';
import { Menu } from 'lucide-react';
import type { Me } from '@/api/types';
import { NAV_ITEMS } from '@/app/nav';
import { Skeleton } from '@/components/ui/skeleton';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { AskLauncherButton } from '@/features/ask';
import { ThemeToggle } from './ThemeToggle';
import { UserMenu } from './UserMenu';

function currentTitle(pathname: string): string {
  const match = NAV_ITEMS.filter((n) => pathname.startsWith(n.to)).sort((a, b) => b.to.length - a.to.length)[0];
  return match?.label ?? 'CIGS';
}

export function TopBar({ me, loading, onAsk }: { me?: Me; loading: boolean; onAsk: () => void }) {
  const { pathname } = useLocation();

  return (
    <header className="sticky top-0 z-30 flex h-14 items-center gap-3 border-b border-border bg-background/95 px-4 backdrop-blur">
      <DropdownMenu>
        <DropdownMenuTrigger
          render={
            <Button variant="ghost" size="icon" className="md:hidden" aria-label="Open navigation">
              <Menu className="h-4 w-4" aria-hidden />
            </Button>
          }
        />
        <DropdownMenuContent align="start">
          {NAV_ITEMS.map((item) => (
            <DropdownMenuItem key={item.to} render={<Link to={item.to}>{item.label}</Link>} />
          ))}
        </DropdownMenuContent>
      </DropdownMenu>

      <h1 className="font-display text-lg font-semibold tracking-tight">{currentTitle(pathname)}</h1>

      <div className="ml-auto flex items-center gap-2">
        <AskLauncherButton onClick={onAsk} />
        {loading ? <Skeleton className="h-8 w-40" /> : <UserMenu me={me} />}
        <ThemeToggle />
      </div>
    </header>
  );
}
